/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "өчигдөр",
        "-2": "уржигдар",
        "0": "өнөөдөр",
        "1": "маргааш",
        "2": "нөгөөдөр",
        "future": {
          "one": "{0} өдрийн дараа",
          "other": "{0} өдрийн дараа"
        },
        "past": {
          "one": "{0} өдрийн өмнө",
          "other": "{0} өдрийн өмнө"
        }
      },
      "day-narrow": {
        "-1": "өчигдөр",
        "-2": "уржигдар",
        "0": "өнөөдөр",
        "1": "маргааш",
        "2": "нөгөөдөр",
        "future": {
          "one": "{0} өдрийн дараа",
          "other": "{0} өдрийн дараа"
        },
        "past": {
          "one": "{0} өдрийн өмнө",
          "other": "{0} өдрийн өмнө"
        }
      },
      "day-short": {
        "-1": "өчигдөр",
        "-2": "уржигдар",
        "0": "өнөөдөр",
        "1": "маргааш",
        "2": "нөгөөдөр",
        "future": {
          "one": "{0} өдрийн дараа",
          "other": "{0} өдрийн дараа"
        },
        "past": {
          "one": "{0} өдрийн өмнө",
          "other": "{0} өдрийн өмнө"
        }
      },
      "hour": {
        "0": "энэ цаг",
        "future": {
          "one": "{0} цагийн дараа",
          "other": "{0} цагийн дараа"
        },
        "past": {
          "one": "{0} цагийн өмнө",
          "other": "{0} цагийн өмнө"
        }
      },
      "hour-narrow": {
        "0": "энэ цаг",
        "future": {
          "one": "{0} ц дараа",
          "other": "{0} ц дараа"
        },
        "past": {
          "one": "{0} ц өмнө",
          "other": "{0} ц өмнө"
        }
      },
      "hour-short": {
        "0": "энэ цаг",
        "future": {
          "one": "{0} ц дараа",
          "other": "{0} ц дараа"
        },
        "past": {
          "one": "{0} ц өмнө",
          "other": "{0} ц өмнө"
        }
      },
      "minute": {
        "0": "энэ минут",
        "future": {
          "one": "{0} минутын дараа",
          "other": "{0} минутын дараа"
        },
        "past": {
          "one": "{0} минутын өмнө",
          "other": "{0} минутын өмнө"
        }
      },
      "minute-narrow": {
        "0": "энэ минут",
        "future": {
          "one": "{0} мин дараа",
          "other": "{0} мин дараа"
        },
        "past": {
          "one": "{0} мин өмнө",
          "other": "{0} мин өмнө"
        }
      },
      "minute-short": {
        "0": "энэ минут",
        "future": {
          "one": "{0} мин дараа",
          "other": "{0} мин дараа"
        },
        "past": {
          "one": "{0} мин өмнө",
          "other": "{0} мин өмнө"
        }
      },
      "month": {
        "-1": "өнгөрсөн сар",
        "0": "энэ сар",
        "1": "ирэх сар",
        "future": {
          "one": "{0} сарын дараа",
          "other": "{0} сарын дараа"
        },
        "past": {
          "one": "{0} сарын өмнө",
          "other": "{0} сарын өмнө"
        }
      },
      "month-narrow": {
        "-1": "өнгөрсөн сар",
        "0": "энэ сар",
        "1": "ирэх сар",
        "future": {
          "one": "{0} сарын дараа",
          "other": "{0} сарын дараа"
        },
        "past": {
          "one": "{0} сарын өмнө",
          "other": "{0} сарын өмнө"
        }
      },
      "month-short": {
        "-1": "өнгөрсөн сар",
        "0": "энэ сар",
        "1": "ирэх сар",
        "future": {
          "one": "{0} сарын дараа",
          "other": "{0} сарын дараа"
        },
        "past": {
          "one": "{0} сарын өмнө",
          "other": "{0} сарын өмнө"
        }
      },
      "nu": ["latn"],
      "quarter": {
        "-1": "өнгөрсөн улирал",
        "0": "энэ улирал",
        "1": "дараагийн улирал",
        "future": {
          "one": "{0} улирлын дараа",
          "other": "{0} улирлын дараа"
        },
        "past": {
          "one": "{0} улирлын өмнө",
          "other": "{0} улирлын өмнө"
        }
      },
      "quarter-narrow": {
        "-1": "өнгөрсөн улирал",
        "0": "энэ улирал",
        "1": "дараагийн улирал",
        "future": {
          "one": "{0} улирлын дараа",
          "other": "{0} улирлын дараа"
        },
        "past": {
          "one": "{0} улирлын өмнө",
          "other": "{0} улирлын өмнө"
        }
      },
      "quarter-short": {
        "-1": "өнгөрсөн улирал",
        "0": "энэ улирал",
        "1": "дараагийн улирал",
        "future": {
          "one": "{0} улирлын дараа",
          "other": "{0} улирлын дараа"
        },
        "past": {
          "one": "{0} улирлын өмнө",
          "other": "{0} улирлын өмнө"
        }
      },
      "second": {
        "0": "одоо",
        "future": {
          "one": "{0} секундын дараа",
          "other": "{0} секундын дараа"
        },
        "past": {
          "one": "{0} секундын өмнө",
          "other": "{0} секундын өмнө"
        }
      },
      "second-narrow": {
        "0": "одоо",
        "future": {
          "one": "{0} сек дараа",
          "other": "{0} сек дараа"
        },
        "past": {
          "one": "{0} сек өмнө",
          "other": "{0} сек өмнө"
        }
      },
      "second-short": {
        "0": "одоо",
        "future": {
          "one": "{0} сек дараа",
          "other": "{0} сек дараа"
        },
        "past": {
          "one": "{0} сек өмнө",
          "other": "{0} сек өмнө"
        }
      },
      "week": {
        "-1": "өнгөрсөн долоо хоног",
        "0": "энэ долоо хоног",
        "1": "ирэх долоо хоног",
        "future": {
          "one": "{0} долоо хоногийн дараа",
          "other": "{0} долоо хоногийн дараа"
        },
        "past": {
          "one": "{0} долоо хоногийн өмнө",
          "other": "{0} долоо хоногийн өмнө"
        }
      },
      "week-narrow": {
        "-1": "өнгөрсөн 7 хоног",
        "0": "энэ 7 хоног",
        "1": "ирэх 7 хоног",
        "future": {
          "one": "{0} 7 хоногийн дараа",
          "other": "{0} 7 хоногийн дараа"
        },
        "past": {
          "one": "{0} 7 хоногийн өмнө",
          "other": "{0} 7 хоногийн өмнө"
        }
      },
      "week-short": {
        "-1": "өнгөрсөн 7 хоног",
        "0": "энэ 7 хоног",
        "1": "ирэх 7 хоног",
        "future": {
          "one": "{0} 7 хоногийн дараа",
          "other": "{0} 7 хоногийн дараа"
        },
        "past": {
          "one": "{0} 7 хоногийн өмнө",
          "other": "{0} 7 хоногийн өмнө"
        }
      },
      "year": {
        "-1": "өнгөрсөн жил",
        "0": "энэ жил",
        "1": "ирэх жил",
        "future": {
          "one": "{0} жилийн дараа",
          "other": "{0} жилийн дараа"
        },
        "past": {
          "one": "{0} жилийн өмнө",
          "other": "{0} жилийн өмнө"
        }
      },
      "year-narrow": {
        "-1": "өнгөрсөн жил",
        "0": "энэ жил",
        "1": "ирэх жил",
        "future": {
          "one": "{0} жилийн дараа",
          "other": "{0} жилийн дараа"
        },
        "past": {
          "one": "{0} жилийн өмнө",
          "other": "{0} жилийн өмнө"
        }
      },
      "year-short": {
        "-1": "өнгөрсөн жил",
        "0": "энэ жил",
        "1": "ирэх жил",
        "future": {
          "one": "{0} жилийн дараа",
          "other": "{0} жилийн дараа"
        },
        "past": {
          "one": "{0} жилийн өмнө",
          "other": "{0} жилийн өмнө"
        }
      }
    },
    "locale": "mn"
  });
}